import React from 'react';
import { saveAs } from "file-saver";

const Header = () => {
    const saveFile = () => {
        saveAs(
            "https://docs.google.com/document/d/1GhzIPVfnX6n10z3NEziKc3hCMOzlr0HYhaES7S9O9W8/edit",
            "Fazri Islam Resume.pdf"
        );
    };

    const url =
        'https://drive.google.com/drive/u/0/my-drive';
    const filename = 'Fazri Islam Resume.pdf';

    return (
        <div className='bg-primary '>
            <div className='lg:flex flex-row'>
                <div className='lg:w-1/2 flex justify-center items-center'>
                    <div>
                        <h2 className='text-5xl font-bold text-neutral'>Fazri Islam</h2>
                        <h3 className='bg-neutral inline-block text-black mt-2 font-semibold px-1 rounded'><small>Front End Web Developer</small></h3>
                        <h3 className='text-3xl text-accent mt-3'>Talk is Cheap.</h3>
                        <h3 className='text-3xl text-accent'>Show me the code</h3>
                        <p className='text-gray-500'>
                            An aspiring developer who loves to take on new projects that challenges his analytical and technological capacities.
                        </p>
                        <button onClick={saveFile} className='btn mt-3 lg:mr-1 text-black'>Download My Resume
                        </button> 
                        <button className='btn mt-3 text-black'>


                            <a href="javascript:void(window.open('https://'blank','scrollbars=yes,toolbar=no,width=700,height=500'))">
                                Contact Me Via Email
                            </a>
                        </button>
                    </div>
                </div>
                <div className='w-1/2 flex justify-center mt-3 mx-auto'>
                    <img className='w-8/12' src="https://i.ibb.co/58NK4kj/theFIB.jpg" alt="" />
                </div>
            </div>

            <div className='lg:w-2/12 w-3/4 ml-20 text-accent lg:ml-60'>
                <div className='flex'>
                    <h2 className='text-5xl font-semibold lg:mr-3 lg:mb-3'>
                        3
                    </h2>
                    <p>
                        <small>
                            Project Completed with <br />
                            React.JS & Node.JS
                        </small>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Header;